import request from '@/utils/request'


//查询门店类型列表
export function typeList(params) {
  return request({
    url: '/admin/store/type/typeList',
    method: 'get',
    params: params
  })
}

//添加轮训图
// export function newsAdd(data) {
//   return request({
//     url: '/admin/storeNews/add',
//     method: 'post',
//     data:data
//   })
// }

//删除
// export function newsInActiveById(params) {
//   return request({
//     url: '/admin/storeNews/inActiveById',
//     method: 'get',
//     params: params
//   })
// }





// WEBPACK FOOTER //
// ./src/api/storeFrontType.js